import { HeaderCellProps } from '../types';

export const TenantCreatorHeaderCell = ({ _customRowProps }: HeaderCellProps) => {
  return <div>Creator</div>;
};
